import React, { useEffect } from 'react';
import { Layout } from './components/ui/Layout';
import { Home } from './Pages/Home/Home.jsx';
import { Route } from "react-router-dom";
import Cookies from 'js-cookie'
import InvoiceStepper from './Pages/Documents/InvoiceStepper.jsx';
import { APP_WEB_URL } from './Utils/enviromentApp.js';
import { useDispatch, useSelector } from 'react-redux';
import { ContactForm } from './Pages/Contact/ContactForm';
import { TicketsList } from './Pages/Ticket/TicketsList';
import { TicketCreation } from './Pages/Ticket/TicketCreation';
import { getUserLogged } from './Store/Ducks/duckAuth';
import { SelectCountry } from './Pages/SelectCountry/SelectCountry';
import { AccountStatus } from './Pages/AccountStatus/AccountStatus';
import { useAppInsights } from "./components/applicationInsightsProvider";
import { snackAction } from './components/CustomSnakbar.jsx'
import { useSnackbar } from "notistack";
import { COOKIE, ROUTES } from './constants'
import { WelcomeDialog } from './components/WelcomeDialog.jsx'
import Dialog from '@mui/material/Dialog';
import { SocietiesList } from './Pages/Home/SocietiesList'
import { getSocieties } from './Store/Ducks/duckSocieties'

const App = () => {
  const appInsights = useAppInsights();
  const { enqueueSnackbar } = useSnackbar();
  const [showWelcome, setShowWelcome] = React.useState(false);
  const [showTaxProfiles, setShowTaxProfiles] = React.useState(false);
  const cookies = Cookies.withConverter({
    read: function (value, name) {

      if (name === 'escaped') {
        return unescape(value)
      }        // Fall back to default for all other cookies
      return Cookies.converter.read(value, name)
    }
  })

  const loggedCookie = cookies.get(COOKIE);
  const dispatch = useDispatch()
  const isLogged = loggedCookie ? true : false;

  useEffect(() => {
    if (!isLogged) window.location.href = `${APP_WEB_URL}/Home/Unauthorized`;
  }, [isLogged])

  useEffect(() => {
    if (isLogged && !sessionStorage.getItem('welcomeShown')) {
      setShowWelcome(true);
      sessionStorage.setItem('welcomeShown', 'true');
    }
  }, [isLogged])

  useEffect(() => {
    dispatch(getUserLogged())
      .then(res => {
        if (res?.payload?.data?.email === null || res?.payload?.data?.email === undefined) {
          if (res?.payload?.status !== 200) {
            enqueueSnackbar(`Error: Status Code ${res?.payload?.status}`, { variant: "error", action: snackAction, autoHideDuration: 3000 });
            appInsights.setAuthenticatedUserContext("Wrong request. Not a 200 status");
            appInsights.trackEvent({
              name: "getUserLogged",
              properties: { Error: `Error: Status Code ${res?.payload?.status}` },
            });
          } else {
            enqueueSnackbar("Error: No se a podido obtener usuario", { variant: "error", action: snackAction, autoHideDuration: 3000 });
            appInsights.setAuthenticatedUserContext("Without User");
            appInsights.trackEvent({
              name: "getUserLogged",
              properties: { Error: "usuario no encontrado" },
            });
            window.location.href = `${APP_WEB_URL}/Account/SignOut`
          }
        }
      })
      .catch(x => {
        if (localStorage.getItem("Email") === 'undefined') {
          appInsights.setAuthenticatedUserContext("Email undefined");
          appInsights.trackEvent({
            name: "getUserLogged",
            properties: { Error: x },
          });
          enqueueSnackbar("Error: No se a podido obtener usuario", { variant: "error", action: snackAction, autoHideDuration: 3000 });
        }
      })

  }, [appInsights, dispatch, enqueueSnackbar]);

  const { authenticatedUser: { email } } = useSelector(state => state.authentication)
  const societies = useSelector(state => state.societies.data)

  const handleOpenTaxProfiles = () => {
    if (societies.length === 0) dispatch(getSocieties());
    setShowWelcome(false);
    setShowTaxProfiles(true);
  }

  return (
    <> {
      isLogged ?
        <>
          <Layout onOpenFaqs={() => setShowWelcome(true)}>
            <Route exact path={ROUTES.HOME}>
              <Home email={email} />
            </Route>
            <Route exact path={ROUTES.DOCUMENTS + ':documentType'}>
              <InvoiceStepper />
            </Route>
            <Route exact path={ROUTES.SELECT_COUNTRY}>
              <SelectCountry />
            </Route>
            <Route exact path={ROUTES.CONTACT_FORM + ':category'}>
              {
                email && <ContactForm email={email} />
              }
            </Route>
            <Route exact path={ROUTES.TICKETS_LIST}>
              {
                email && <TicketsList email={email} />
              }
            </Route>
            <Route exact path={ROUTES.TICKET_CREATION}>
              {
                email && <TicketCreation email={email} />
              }
            </Route>
            <Route exact path={ROUTES.ACCOUNT_STATUS}>
              {
                email && <AccountStatus email={email} />
              }
            </Route>
          </Layout>
          <WelcomeDialog open={showWelcome} onClose={() => setShowWelcome(false)} onOpenTaxProfiles={handleOpenTaxProfiles} />
          <Dialog maxWidth="lg" onClose={() => setShowTaxProfiles(false)} open={showTaxProfiles}>
            <SocietiesList open={showTaxProfiles} societies={societies} isDownload={true} showAll={true} />
          </Dialog>
        </>
        :
        <div style={{ marginTop: "20px", marginLeft: "15px" }}><b>Redirect to login...</b> </div>
    }
    </>
  );
}
export default App;
